import React from "react";
import { List } from "../modules/Submissions";

export function SubmissionsPage() {
  return <List />;
}
